// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6816":"9bc7bae2d3f03059","7913":"637aa68efb8c7067"}[chunkId] + ".js";
};